import styled from 'styled-components';

import { brandFont } from 'components/layout/brand-font';
import { PaymentMethodsContainer } from 'components/payment-method-select';
import { primitive } from 'styles/constants/primitives';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 0 ${primitive.$spacing8} 0;

  ${Styles.desktop`
    margin-top: calc(80px + 5vh);
    width: 90%;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: ${primitive.$spacing10};
  `}
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 ${primitive.$spacing4};

  ${Styles.desktop`
    width: 500px;
    margin: 0 auto;
  `}
`;

export const FundingSourceSection = styled.section`
  display: flex;
  flex-direction: column;
  padding: ${primitive.$spacing9} 0;
`;

export const GiftCardInfoContainer = styled.div`
  padding: ${primitive.$spacing4} 0 ${primitive.$spacing7} 0;
  margin-bottom: ${primitive.$spacing4};
`;

export const Heading = styled.h2`
  font-weight: 600;
  text-align: center;
`;

export const SubHeading = styled.h5`
  display: flex;
  flex: 1;
  font: ${brandFont.headerThree};
  padding: ${primitive.$spacing3} 0;
  margin: 0;
`;

export const SubHeadingCentered = styled(SubHeading)`
  text-align: center;
  justify-content: center;
  margin-top: ${primitive.$spacing4};
`;

export const Separator = styled.div`
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  width: fill-available;
  margin: 0 -${primitive.$spacing4};

  ${Styles.desktop`
    margin: 0;
  `}
`;

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${primitive.$spacing5};
`;

export const PaymentMethodContainer = styled.div`
  padding: ${primitive.$spacing4} 0;
  ${PaymentMethodsContainer} {
    border: 1px solid ${p => p.theme.token('border-color-default')};
  }
`;

export const WarningContainer = styled.div`
  padding-bottom: 0.5rem;
`;
